<template>
  <StationDetails v-if="stationId || createNewStation" :stationId="stationId" :createNew="createNewStation" />
</template>

<script>
import StationDetails from '@/components/StationDetails.vue'

export default {
  name: 'EditWeatherStation',
  components: {
    StationDetails
  },
  data: () => {
    return {
      stationId: undefined,
      createNewStation: false
    }
  },
  mounted() {
    const routeId = this.$route.params.id

    switch(routeId) {
      case "create":
        this.createNewStation = true
        break
      default:
        this.stationId = routeId
        break
    }
  }
}
</script>
